import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import { MediaFragmentDoc } from '../../../fragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UploadFileCreateMediaMutationVariables = Types.Exact<{
  input: Types.MediaInput;
}>;


export type UploadFileCreateMediaMutation = { __typename?: 'Mutation', createMedia: { __typename?: 'MediaMutationResult', success: boolean, error?: { __typename?: 'Error', code: string } | null, media?: { __typename?: 'Media', id: number, loopVideo: boolean, hideVideoControls: boolean, unoptimizedUrl?: string | null, createdAt: string, updatedAt: string, thumbnailImageUrl?: string | null, aiEditSource?: { __typename?: 'Media', id: number, mediaUrls: { __typename?: 'TranslationSet', en: string } } | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null, trainingResourceVersions?: Array<{ __typename?: 'TrainingResourceVersion', id: string, trainingResource: { __typename?: 'TrainingResource', id: string, libraryItem: { __typename?: 'LibraryItem', id: string, name: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> } } } }> | null } | null } };


export const UploadFileCreateMediaDocument = gql`
    mutation UploadFileCreateMedia($input: MediaInput!) {
  createMedia(input: $input) {
    success
    error {
      code
    }
    media {
      ...Media
    }
  }
}
    ${MediaFragmentDoc}`;
export type UploadFileCreateMediaMutationFn = Apollo.MutationFunction<UploadFileCreateMediaMutation, UploadFileCreateMediaMutationVariables>;

/**
 * __useUploadFileCreateMediaMutation__
 *
 * To run a mutation, you first call `useUploadFileCreateMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadFileCreateMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadFileCreateMediaMutation, { data, loading, error }] = useUploadFileCreateMediaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadFileCreateMediaMutation(baseOptions?: Apollo.MutationHookOptions<UploadFileCreateMediaMutation, UploadFileCreateMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadFileCreateMediaMutation, UploadFileCreateMediaMutationVariables>(UploadFileCreateMediaDocument, options);
      }
export type UploadFileCreateMediaMutationHookResult = ReturnType<typeof useUploadFileCreateMediaMutation>;
export type UploadFileCreateMediaMutationResult = Apollo.MutationResult<UploadFileCreateMediaMutation>;
export type UploadFileCreateMediaMutationOptions = Apollo.BaseMutationOptions<UploadFileCreateMediaMutation, UploadFileCreateMediaMutationVariables>;